import { Card, CardContent } from "@/components/ui/card";

export function StatCard({ label, value, icon: Icon, accent = "primary", testId }) {
    const tone = {
        primary: "bg-primary-soft text-primary",
        success: "bg-success-soft text-success",
        warning: "bg-warning-soft text-warning",
        destructive: "bg-destructive-soft text-destructive",
    }[accent];
    return (
        <Card data-testid={testId} className="border-border">
            <CardContent className="p-5 flex items-center gap-4">
                <div className={`h-11 w-11 rounded-md grid place-items-center ${tone}`}>
                    {Icon && <Icon className="h-5 w-5" />}
                </div>
                <div>
                    <p className="text-xs uppercase tracking-widest text-muted-foreground">{label}</p>
                    <p className="font-mono text-2xl font-semibold leading-tight">{value}</p>
                </div>
            </CardContent>
        </Card>
    );
}

export function PageHeader({ title, subtitle, actions }) {
    return (
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-6">
            <div>
                <h1 className="text-2xl md:text-3xl font-heading font-bold tracking-tight">{title}</h1>
                {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
            </div>
            {actions && <div className="flex gap-2">{actions}</div>}
        </div>
    );
}

export function EmptyState({ title, description, action }) {
    return (
        <div className="text-center border border-dashed border-border rounded-lg p-12">
            <p className="font-heading font-semibold text-lg">{title}</p>
            {description && <p className="text-muted-foreground text-sm mt-1">{description}</p>}
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
}
